import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./components/addin/addin-styles.css";
import { TestClockProvider } from "./contexts/TestClockContext";

const rootElement = document.getElementById("root")!;

// Always render the App with React Router (including /addin route)
createRoot(rootElement).render(
  <TestClockProvider>
    <App />
  </TestClockProvider>
);
